import moment from "moment";
import { useEffect, useState } from "react";
import { Message } from "semantic-ui-react";
import { Appointment } from "../../modals/Appointment";
import { bookLoanCar } from "../../Services/LockBoxService";
import PickUpCalendar from "./PickUpCalendar/PickUpCalendar";
import PickUpDisplay from "./PickUpDisplay/PickUpDisplay";
import PickUpStepper from "./PickUpStepper/PickUpStepper";
import PickUpSummary from "./PickUpSummary/PickUpSummary";
import PickUpTime from "./PickUpTime/PickUpTime";
import { JobEstimationDetail } from "../../modals/JobEstimationDetail";
import { IBSAdonisService } from "../../Services/IBSAdonisService";
import { IDS } from "../../constants/Ids";

interface PickUpProps {
  estimateDetails: JobEstimationDetail;
}

const PickUp = (props: PickUpProps) => {
  const ibsAdonisService = new IBSAdonisService();

  const taskListId = IDS.TASK_LIST.PICKUP;

  const [isDone, setIsDone] = useState(false);
  const [pickTask, setPickTask] = useState<Appointment>();

  const [step, setStep] = useState(1);
  const [pickUpDate, setPickUpDate] = useState();
  const [pickUpTime, setPickUpTime] = useState(null);
  const [lockBox, setLockBox] = useState(null);
  const [isLockBoxAvailable, setIsLockBoxAvailable] = useState(true);

  const [showLoader, setShowLoader] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    checkIfDone();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onConfirm = async () => {
    setShowLoader(true);
    try {
      await assignLockBox();
      await checkIfDone();
      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
      }, 2000);
    } catch (err) {
      throw new Error("Data could not be fetched!");
    } finally {
      setShowLoader(false);
    }
  };

  const assignLockBox = async () => {
    if (lockBox)
      await bookLoanCar(moment(pickUpDate), props.estimateDetails, lockBox);
  };

  const checkIfDone = async () => {
    setShowLoader(true);
    try {
      const data = await ibsAdonisService.getTasksForUser(taskListId);
      const task = data?.Data?.filter(
        (x: any) =>
          x.assignments.filter(
            (y: any) => y.assignedToId === props.estimateDetails.estimateId
          ).length > 0 && !x.isCompleted
      )[0];

      setIsDone(!!task);
      setPickTask(task);
    } catch (err) {
      throw new Error("Data could not be fetched!");
    } finally {
      setShowLoader(false);
    }
  };

  return (
    <div className="mt-1">
      <p className="heading">Job completed!</p>
      <br></br>
      {success && (
        <Message
          success
          header=""
          content="Your pick up details have been saved"
        />
      )}
      {isDone ? (
        <PickUpDisplay
          estimateDetails={props.estimateDetails}
          task={pickTask}
        ></PickUpDisplay>
      ) : (
        <>
          <p>Ready for pick up.</p>
          <PickUpStepper
            step={step}
            pickUpDate={pickUpDate}
            pickUpTime={pickUpTime}
          ></PickUpStepper>
          {step === 1 ? (
            <PickUpCalendar
              estimateDetails={props.estimateDetails}
              setDateSelected={setPickUpDate}
              preSelectedDate={pickUpDate}
            ></PickUpCalendar>
          ) : step === 2 ? (
            <PickUpTime
              preDateSelected={pickUpDate}
              setTimeSelected={setPickUpTime}
              preTimeSelected={pickUpTime}
              preLockBoxSelected={lockBox}
              setLockBox={setLockBox}
              setLockBoxAvailable={setIsLockBoxAvailable}
              setShowLoader={setShowLoader}
            ></PickUpTime>
          ) : step === 3 ? (
            <PickUpSummary
              estimateDetails={props.estimateDetails}
              pickUpDate={moment(pickUpDate)}
              pickUpTime={pickUpTime}
            ></PickUpSummary>
          ) : null}
          <div className="stepper-control">
            {step !== 1 && (
              <button onClick={() => setStep(step - 1)}>Back</button>
            )}
            {step !== 3 && (
              <button
                onClick={() => setStep(step + 1)}
                className={
                  (step === 1 && !pickUpDate) ||
                  (step === 2 && (!pickUpTime || !isLockBoxAvailable))
                    ? "disabled"
                    : ""
                }
              >
                Next
                {showLoader && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginLeft: "5px" }}
                  />
                )}
              </button>
            )}
            {step === 3 && (
              <button
                disabled={showLoader}
                onClick={(e) => {
                  onConfirm();
                }}
              >
                Confirm
                {showLoader && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginLeft: "5px" }}
                  />
                )}
              </button>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default PickUp;
